import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import { NavmenuActions } from "@skills-app/core/actions";
import { ISkillGroup } from "@skills-app/models/skillGroup";
import { ISkillNode } from "@skills-app/models/skillNode";
import {
  EditSkillGroupActions,
  SkillGroupApiActions,
  UpdateSkillGroupPageActions,
} from "@skills-app/skill-groups/actions";

export interface ISkillGroupsState {
  selectedSkillGroup: ISkillGroup | null;
  selectedSkillGroupSkills: ISkillNode[];
  skillGroups: ISkillGroup[];
  selectedGroup: ISkillGroup | null;
  skillGroupsForCapability: ISkillGroup[];
  isLoading: ISkillGroupLoading;
}

export interface ISkillGroupLoading {
  addSkillGroup: boolean;
  editSkillGroup: boolean;
  deleteSkillGroup: boolean;
}

const initialState: ISkillGroupsState = {
  selectedSkillGroup: null,
  selectedSkillGroupSkills: [],
  skillGroups: [],
  selectedGroup: null,
  skillGroupsForCapability: [],
  isLoading: {
    addSkillGroup: false,
    editSkillGroup: false,
    deleteSkillGroup: false,
  },
};

export const reducer = createReducer(
  initialState,
  on(SkillGroupApiActions.requestSkillGroupByIdSuccess, (state, action) => ({
    ...state,
    selectedSkillGroup: action.skillGroup,
  })),
  on(SkillGroupApiActions.requestSkillGroupByIdError, (state) => ({
    ...state,
    selectedSkillGroup: null,
  })),
  on(SkillGroupApiActions.getSkillGroupsSuccess, (state, action) => ({
    ...state,
    skillGroups: action.skillGroups,
  })),
  on(SkillGroupApiActions.upsertSkillGroupSuccess, (state, action) => ({
    ...state,
    selectedSkillGroup: action.skillGroup ? action.skillGroup : null,
  })),
  on(SkillGroupApiActions.getSkillGroupsForTypeSuccess, (state, action) => ({
    ...state,
    skillGroupsForCapability: action.skillGroups,
  })),
  on(EditSkillGroupActions.skillGroupEditRequest, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, editSkillGroup: true },
  })),
  on(EditSkillGroupActions.skillGroupEditSuccess, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, editSkillGroup: false },
  })),
  on(EditSkillGroupActions.skillGroupEditError, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, editSkillGroup: false },
  })),
  on(SkillGroupApiActions.deleteSkillGroup, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, deleteSkillGroup: true },
  })),
  on(SkillGroupApiActions.deleteSkillGroupSuccess, (state) => ({
    ...state,
    selectedSkillGroup: null,
    isLoading: { ...state.isLoading, deleteSkillGroup: false },
  })),
  on(
    UpdateSkillGroupPageActions.clearSkillGroupSelection,
    UpdateSkillGroupPageActions.deleteSkillDialogClosed,
    (state) => ({
      ...state,
      selectedSkillGroup: null,
    }),
  ),
  on(NavmenuActions.endNavigation, (state) => ({
    ...state,
    selectedSkillGroup: null,
    selectedSkillGroupSkills: [],
    selectedGroup: null,
    skillGroupsForCapability: [],
    isLoading: {
      addSkillGroup: false,
      editSkillGroup: false,
      deleteSkillGroup: false,
    },
  })),
);

export const getSkillGroupsState =
  createFeatureSelector<ISkillGroupsState>("skillGroups");

export const getSelectedSkillGroup = createSelector(
  getSkillGroupsState,
  (skillGroupsState) => skillGroupsState.selectedSkillGroup,
);

export const getSelectedSkillGroupSkills = createSelector(
  getSkillGroupsState,
  (skillGroupsState) => skillGroupsState.selectedSkillGroupSkills,
);

export const getSelectedSkillChampions = createSelector(
  getSkillGroupsState,
  (skillGroupsState) => {
    return skillGroupsState.selectedGroup;
  },
);

export const getSkillGroupLoading = createSelector(
  getSkillGroupsState,
  (skillGroupsState) => {
    return skillGroupsState.isLoading;
  },
);

export const getSkillGroups = createSelector(getSkillGroupsState, (state) => {
  return state.skillGroups;
});

export const getSkillGroupsForCapability = createSelector(
  getSkillGroupsState,
  (skillGroupsState) => {
    return skillGroupsState.skillGroupsForCapability;
  },
);
